<div *ngIf="tabs && tabs.length > 0">
    <app-tabs tabsId="filemanager" [tabs]="tabs" (tabChanged)="updateActiveTabId($event)"></app-tabs>
    <div *ngIf="activeTabId == 'upload'">
        <app-uploadimage [uploadOnly]="uploadOnly" (onUploaded)="updateSelectedImages($event)" (onComplete)="complete($event)" [limit]="limit" [sourceDocumentId]="sourceDocumentId" [sourceDocumentImageType]="sourceDocumentImageType"></app-uploadimage>
    </div>
    <div *ngIf="activeTabId == 'media'">
        <app-filemanagerfiles [selectedImages]="selectedImages" (onComplete)="complete($event)" [limit]="limit" [sourceDocumentId]="sourceDocumentId" [sourceDocumentImageType]="sourceDocumentImageType"></app-filemanagerfiles>
    </div>
</div>
